import {
    SpecialGeometryType,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-interaction.interface';
import { ElementType, GroupingResult, IGeometryElement } from '@tencent/chart/lib/chart-ui/interface';
import { isLineShape } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/chart-elements/base';

export function specialTypeElementsGrouping(
    allElements: IGeometryElement[],
    data: any,
): GroupingResult<IGeometryElement> | undefined {
    const seriesName = Array.isArray(data) ? data[0].name : data.name;
    const { specialGeometryType } = Array.isArray(data) ? data[0] : data;

    const sameSpecialTypeElements = allElements
        .filter(ele => getElementData(ele)?.specialGeometryType === specialGeometryType);

    // 箱体图 根据箱体类型进行分组
    if (specialGeometryType === SpecialGeometryType.upDownBar) {
        const { barType } = data;
        return {
            groupId: `upDownBars_${barType}`,
            elements: sameSpecialTypeElements.filter(ele => getElementData(ele)?.barType === barType),
            singleSelectable: false,
        };
    }

    // 烛台图 单独分类
    if (specialGeometryType === SpecialGeometryType.highLowLine) {
        return {
            groupId: 'stick',
            elements: sameSpecialTypeElements,
            singleSelectable: false,
        };
    }

    // 趋势线和普通图形 同样拥有seriesId, 这里区分开，避免趋势线和图形分到一组
    if (specialGeometryType === SpecialGeometryType.trendLine) {
        // 同一个系列可能有多个趋势线，他们只能单独被选中，这里直接通过趋势线的系列名区分
        const result = {
            groupId: `trendline_${seriesName}`, // 趋势线data的系列名为趋势线名称
            ...sameSpecialTypeElements.find(ele => getElementData(ele)?.name === seriesName),
        };

        return result as any;
    }
}

function getElementData(ele: IGeometryElement) {
    return Array.isArray(ele.data) ? ele.data[0] : ele.data;
}

export function seriesIdGrouping(
    targetCfg: any,
    allElements: IGeometryElement[],
    data: any,
    groupType: ElementType,
): GroupingResult<IGeometryElement>  {
    const seriesId = Array.isArray(data) ? data[0].seriesId : data.seriesId;
    const groupId = `${groupType}-series-${seriesId}-${targetCfg.name}`;
    const elementList = allElements.filter((ele) => {
        const { data } = ele;
        const eleSeriesId = Array.isArray(data) ? data[0].seriesId : data.seriesId;
        return eleSeriesId === seriesId;
    }).map(ele => ({
        ...ele,
        groupId,
    }));

    return {
        groupId,
        elements: elementList,
        singleSelectable: !isLineShape(elementList[0]?.shapeType),
    };
}
